import React, { CSSProperties, FC, ReactNode } from "react";
import "./styles.scss";
import useDevice from "../../utils/hooks/useDevice";

type TagOptions = "p" | "h1" | "h2" | "h3" | "label" | "div" | "span";
type VariantOptions = "subtitle" | "body1" | "body2";

type BaseProps = {
  className?: string;
  children: string | ReactNode;
  style?: CSSProperties;
  htmlFor?: string;
};

type PropsWithTag<T extends TagOptions> = T extends "p"
  ? {
      tag: T;
      variants: VariantOptions;
    } & BaseProps
  : {
      tag: T;
      variants?: never;
    } & BaseProps;

type Props = PropsWithTag<TagOptions>;

const Label: FC<Props> = ({
  tag,
  className = "",
  children,
  variants,
  style,
  htmlFor,
}) => {
  const Tag = tag;
  const { isMobile } = useDevice();
  const classNames =
    variants && isMobile
      ? `label ${tag}-label__mobile ${className} ${variants}__mobile`
      : !variants && isMobile
      ? `label ${tag}-label__mobile ${className}`
      : variants && !isMobile
      ? `label ${tag}-label ${className} ${variants}`
      : `label ${tag}-label ${className}`;

  return (
    <Tag className={classNames} style={style} htmlFor={htmlFor}>
      {children}
    </Tag>
  );
};

export default Label;
